(() => {
  // ---------- Storage ----------
  function getStorageKey(picker) {
    const productId =
      picker?.dataset?.productId ||
      document.querySelector("variant-picker")?.dataset?.productId ||
      document.querySelector("[data-product-id]")?.getAttribute("data-product-id") ||
      "product";

    return `aqbeds_variant_tab_${productId}`;
  }

  function saveActiveTab(picker, index) {
    try {
      const key = getStorageKey(picker);
      localStorage.setItem(
        key,
        JSON.stringify({
          index: String(index),
          timestamp: Date.now(),
        })
      );
    } catch (e) {}
  }

  function loadActiveTab(picker) {
    try {
      const key = getStorageKey(picker);
      const saved = localStorage.getItem(key);
      if (!saved) return null;

      const data = JSON.parse(saved);
      if (!data || data.index == null) return null;

      // expire after 7 days
      if (Date.now() - (data.timestamp || 0) > 7 * 24 * 60 * 60 * 1000) {
        localStorage.removeItem(key);
        return null;
      }

      return String(data.index);
    } catch (e) {
      return null;
    }
  }

  // ---------- Core ----------
  function setActiveTab(picker, index, { persist = true } = {}) {
    if (!picker) return;

    const tabs = picker.querySelectorAll(".variant-tab[data-option-index]");
    const panels = picker.querySelectorAll(".variant-tab-panel[data-option-panel]");

    if (!tabs.length || !panels.length) return;

    const idx = String(index);

    // validate index
    const validTab = picker.querySelector(
      `.variant-tab[data-option-index="${idx}"]`
    );

    const finalIdx = validTab
      ? idx
      : String(tabs[0].getAttribute("data-option-index") || "0");

    if (persist) {
      saveActiveTab(picker, finalIdx);
    }

    // Update tabs
    tabs.forEach((t) => {
      const active = t.getAttribute("data-option-index") === finalIdx;
      t.classList.toggle("is-active", active);
      t.setAttribute("aria-selected", active ? "true" : "false");
      t.setAttribute("tabindex", active ? "0" : "-1");
    });

    // Update panels
    panels.forEach((p) => {
      const active = p.getAttribute("data-option-panel") === finalIdx;
      p.classList.toggle("is-active", active);
      if (active) p.removeAttribute("hidden");
      else p.setAttribute("hidden", "");
    });

    // Restore saved color for this tab
    try {
      const savedColor = localStorage.getItem(`selected_color_${finalIdx}`);
      if (savedColor) {
        const input = picker.querySelector(
          `.variant-tab-panel[data-option-panel="${finalIdx}"] input[value="${savedColor}"]`
        );
        if (input) {
          input.checked = true;
          const gridItem = input.closest(".color-grid-item");
          if (gridItem) {
            gridItem.classList.add("selected");
          }
        }
      }
    } catch (e) {}
  }

  function updateTabSelectedTextFromInputs(picker) {
    if (!picker) return;

    const panels = picker.querySelectorAll(".variant-tab-panel[data-option-panel]");

    panels.forEach((panel) => {
      const idx = panel.getAttribute("data-option-panel");
      const tab = picker.querySelector(
        `.variant-tab[data-option-index="${idx}"]`
      );
      const selectedTextEl = tab?.querySelector("[data-selected-text]");

      if (!tab || !selectedTextEl) return;

      const checkedRadio = panel.querySelector(
        'input[type="radio"]:checked'
      );
      const select = panel.querySelector("select");

      // Clear selected class
      panel
        .querySelectorAll(".color-grid-item")
        .forEach((item) => item.classList.remove("selected"));

      if (checkedRadio) {
        selectedTextEl.textContent = checkedRadio.value || "";

        try {
          localStorage.setItem(
            `selected_color_${idx}`,
            checkedRadio.value
          );
        } catch (e) {}

        const gridItem = checkedRadio.closest(".color-grid-item");
        if (gridItem) {
          gridItem.classList.add("selected");
        }
      } else if (select) {
        selectedTextEl.textContent =
          select.options[select.selectedIndex]?.textContent?.trim() || "";
      }
    });
  }

  function initOrRestore(picker) {
    if (!picker) return;

    const fromStorage = loadActiveTab(picker);
    const index = fromStorage ?? "0";

    setActiveTab(picker, index, { persist: false });
    updateTabSelectedTextFromInputs(picker);
  }

  // ---------- Runner ----------
  document.addEventListener("DOMContentLoaded", () => {
    const picker =
      document.querySelector("variant-picker") ||
      document.querySelector("[data-variant-picker]") ||
      document.body;

    // Initial restore
    setTimeout(() => initOrRestore(picker), 50);

    // Tab click (event delegation)
    document.addEventListener("click", (e) => {
      const tab = e.target.closest(".variant-tab[data-option-index]");
      if (!tab) return;

      const p = tab.closest("variant-picker") || picker;
      const idx = tab.getAttribute("data-option-index");
      if (idx == null) return;

      setActiveTab(p, idx, { persist: true });
    });

    // Option change
    document.addEventListener("change", (e) => {
      const target = e.target;

      if (
        target.matches('.variant-tab-panel input[type="radio"]') ||
        target.matches(".variant-tab-panel select")
      ) {
        const p = target.closest("variant-picker") || picker;
        updateTabSelectedTextFromInputs(p);
      }
    });

    // Debounced MutationObserver (prevents flicker)
    let mutationTimeout = null;

    const observer = new MutationObserver(() => {
      clearTimeout(mutationTimeout);
      mutationTimeout = setTimeout(() => {
        initOrRestore(picker);
      }, 80);
    });

    observer.observe(picker, {
      childList: true,
      subtree: true,
    });

    // Variant events (Horizon safe)
    document.addEventListener("variant:change", () =>
      setTimeout(() => initOrRestore(picker), 50)
    );
    document.addEventListener("variant:changed", () =>
      setTimeout(() => initOrRestore(picker), 50)
    );
    document.addEventListener("product:variant-change", () =>
      setTimeout(() => initOrRestore(picker), 50)
    );
  });
})();
